import {useState} from "react";
import {doc, getDoc, getFirestore, setDoc} from "firebase/firestore";
import swal from "sweetalert";
import { Dropdown, } from 'react-bootstrap';

const db = getFirestore();


export default function AddNewCeleb(props){
    const [celebId,setCelebId]=useState("");
    const [dropped,setDropped]=useState(true);

    const handleCelebIdChange=(e)=>{
        setCelebId(e.target.value);
        console.log(e.target.value);
    }


    const addNewCeleb=async ()=>{

        setDropped(!dropped);
        if(celebId.trim()!=""){
            let ref= await getDoc(doc(db,"appSettings","categories"));
            let data=ref.data()["categories"];
            data[props.categoryIndex]["celebrities"].push(celebId);
            setDoc(doc(db,"appSettings","categories"),{"categories":data},{merge:true})
            setDoc(doc(db,"appSettings","categories"),{"categories":data},{merge:true})
            console.log('added');
        }
        else{
            // alert("Celebrity ID is Empty");
            swal("Celebrity ID is empty")
        }

    }

    return (
        <div className="p-1 h-full w-full flex flex-col gap-5 justify-center items-center border-white/40 shadow-xl border-1">

            <div className="text-xl font-bold flex justify-center items-center text-center">
                Add New Celebrity
            </div>


            <input
                className="p-2 text-black w-3/4"
                placeholder="Celebrity Id"
                onChange={(e)=>handleCelebIdChange(e)}
            />

                <button
                    onClick={()=>{addNewCeleb()}}
                    className="hover:scale-105 hover:bg-blue-400 hover:text-white bg-white p-1 text-black rounded w-24 flex justify-center items-center">
                        Add
                </button>



        </div>
    )
}